import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 350 } }

  debounce(event) {
    this.clear()
    const form = event.currentTarget.form
    this.timeout = setTimeout(() => form.requestSubmit(), this.delayValue)
  }

  clear() {
    clearTimeout(this.timeout)
    this.timeout = null
  }

  clearAndSubmit(event) {
    event.preventDefault()
    this.clear()
    this.inputTarget.value = ""
    this.element.requestSubmit()
  }

  disconnect() {
    this.clear()
  }
}
